import { useEffect } from "react";
import {
  Nav,
  HeroV3,
  TrustStrip,
  LogoStrip,
  DevelopmentOverview,
  HowItWorks,
  ServicesGrid,
  HorizontalFeatures,
  MarketingCreative,
  CaseStudies,
  Testimonials,
  FAQ,
  FinalCTA,
  Blog,
  Footer,
} from "../App";

/**
 * HomeV3 — cinematic light beam hero.
 * Uses HeroV3 (new ambient) while keeping the rest of the page
 * identical to V1/V2/V4 so visitors can compare hero treatments.
 */
export default function HomeV3() {
  useEffect(() => {
    document.title = "Sunday Digital — V3";
  }, []);

  return (
    <div
      data-testid="home-page"
      data-variant="v3"
      className="min-h-screen bg-[#0B0F14] text-neutral-100 font-body"
    >
      <Nav />
      <main>
        <HeroV3 />
        <TrustStrip />
        <LogoStrip />
        <DevelopmentOverview />
        <HowItWorks />
        <ServicesGrid />
        <HorizontalFeatures />
        <MarketingCreative />
        <CaseStudies />
        <Testimonials />
        <FAQ />
        <FinalCTA />
        <Blog />
      </main>
      <Footer />
    </div>
  );
}
